import API from "../api";
import { ConfigHelper } from "../helpers/config-helper";
import App from "../models/app";

export default class MgrBase {
    _config: App = {};

    constructor(config = {}) {
        this._config = config;
    }

    async init() {
        console.warn("init not implemented");
    }

    async requestPermission() {
        console.warn("requestPermission not implemented");
    }

    hasPermission() {
        console.warn("hasPermission not implemented");
    }

    hasNotPermission() {
        console.warn("hasPermission not implemented");
    }

    /**
     * call an API to register token on backend
     * @param {*} token
     * @param {*} service
     * @returns Promise<Object>
     */
    async registerDevice(token) {
        try {
            const { success = 0 } = await API.register({
                token,
                service: this._getService(),
                registrationHost: this._config.getHost(),
                verBBE: this._config.getVerBBE(),
                packageName: this._config.getPackageName(),
                pSetup: this._config.getPSetup()
            });
            await ConfigHelper.saveDeviceRegistration({
                success: success === 1,
                time: new Date().getTime()
            });
        } catch (e) {
            console.log(e.message);
        }
    }

    /**
     * call super.validate(config) if you need this validation checks
     * @param {*} config
     * @returns
     */
    validate() {
        this._config.validate();
    }

    _getConfig(): App {
        return this._config;
    }

    _getService(): String {
        return "";
    }
}
